export const dashboardBase = 'https://tiltingpoint.tryretool.com/embedded/public/';

export const dashboardIds = {
  dataTools: '4be714b9-482f-4f7f-923f-2e7b0cd4728d',
  spongebob: '04d61034-7ce0-4997-aa49-4f238369681b',
  retool: '3fb973aa-50fb-47a9-9908-477db1c98bbd',
};
